import { Component } from '@angular/core';
import { SUPPORT_EMAIL } from '../../../../app.constants';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.page.html',
  styleUrl: '../legal.page.scss'
})
export class PrivacyPage {
  readonly supportEmail = SUPPORT_EMAIL;
}
